/* WF Shop de look 8-10-2026. Maatkeuze per stuk, "Voeg toe" en "Voeg hele look toe" via /cart/add.js (items[]), daarna de bestaande cart-drawer verversen en openen. */
if (!customElements.get('wf-look')) {
  customElements.define('wf-look', class WfLook extends HTMLElement {
    connectedCallback() {
      const cur = this.querySelector('[data-wf-current]');
      this.current = cur ? JSON.parse(cur.textContent) : null;
      this.addEventListener('click', (e) => {
        const one = e.target.closest('[data-wf-add]');
        const all = e.target.closest('[data-wf-add-all]');
        if (one) this.addOne(one);
        else if (all) this.addAll(all);
      });
      this.addEventListener('change', (e) => {
        const row = e.target.closest('[data-wf-row]');
        if (row) this.mark(row, null);
        this.err(null);
      });
      if (this.current) {
        this.showCurrent();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.showCurrent(), 50));
        }
        document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('product-info')) setTimeout(() => this.showCurrent(), 80); });
      }
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); }

    mainVariantId() {
      const el = document.querySelector('product-info input[name="id"], .product-form input[name="id"], form[action*="/cart/add"] input[name="id"]');
      return el ? String(el.value) : null;
    }
    showCurrent() {
      const line = this.querySelector('[data-wf-current-line]');
      if (!line || !this.current) return;
      const v = this.current.variants[this.mainVariantId()];
      if (!v) { line.hidden = true; return; }
      line.hidden = false;
      line.textContent = v.available ? this.str('current', { size: v.size, title: this.current.title }) : this.str('current_out', { size: v.size, title: this.current.title });
    }
    str(k, vars = {}) {
      const s = (window.wfLookStrings && window.wfLookStrings[k]) || '';
      return s.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, n) => vars[n] ?? '');
    }
    mark(row, msg) {
      row.classList.toggle('is-missing', !!msg);
      const el = row.querySelector('[data-wf-err]');
      if (el) { el.textContent = msg || ''; el.hidden = !msg; }
    }
    err(msg) {
      const el = this.querySelector('[data-wf-err-all]');
      if (el) { el.textContent = msg || ''; el.hidden = !msg; }
    }
    chosen(row) { const r = row.querySelector('input[type="radio"]:checked'); return r ? Number(r.value) : null; }

    addOne(btn) {
      const row = btn.closest('[data-wf-row]');
      const id = this.chosen(row);
      if (!id) { this.mark(row, this.str('pick_size')); return; }
      this.add([{ id, quantity: 1 }], btn, row);
    }
    addAll(btn) {
      const rows = [...this.querySelectorAll('[data-wf-row]')];
      const items = [];
      let first = null;
      rows.forEach((row) => {
        const id = this.chosen(row);
        if (!id) { this.mark(row, this.str('pick_size')); first = first || row; } else items.push({ id, quantity: 1 });
      });
      if (first) { first.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      if (this.current) {
        const v = this.current.variants[this.mainVariantId()];
        if (!v || !v.available) { this.err(this.str('current_out', { size: v ? v.size : '', title: this.current.title })); return; }
        items.unshift({ id: Number(this.mainVariantId()), quantity: 1 });
      }
      this.add(items, btn, null);
    }

    async add(items, btn, row) {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const label = btn.querySelector('span');
      const old = label.textContent;
      btn.setAttribute('aria-disabled', 'true');
      label.textContent = this.str('adding');
      this.err(null);
      const body = { items };
      if (cart) { body.sections = cart.getSectionsToRender().map((s) => s.id).join(','); body.sections_url = window.location.pathname; }
      try {
        const res = await fetch(`${window.routes.cart_add_url}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || this.str('error'));
        if (!cart || !cart.renderContents || !json.sections) { window.location = window.routes.cart_url; return; }
        if (cart.setActiveElement) cart.setActiveElement(btn);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wf-look', cartData: json });
        cart.renderContents(json);
        cart.classList.remove('is-empty'); // zoals product-form.js: lege-staat van de lade uit
        label.textContent = this.str('added');
        setTimeout(() => { label.textContent = old; }, 2200);
      } catch (e) {
        label.textContent = old;
        const msg = e.message || this.str('error');
        if (row) this.mark(row, msg); else this.err(msg);
      } finally {
        btn.removeAttribute('aria-disabled');
      }
    }
  });
}
